module.exports = __webpack_public_path__ + "media/images/footer-background-226de2b7a4dbc4ca9a36170fec20c3ea.png";